$(function() {
  // initNewsletter();
  initBackToTop();

  // amsterdam
  var amsterdam = $('.page-tih-city-amsterdam');
  if (amsterdam.length == 1) {
    initGalleryGrid(amsterdam, 6, 'amsterdam');
    initGallerySlideshow(amsterdam, '.tih-city-gallery-thumbs', '.tih-city-gallery-slideshow', 15, 'amsterdam');
    initGallerySlideshowCursor(amsterdam);
    initVideo(amsterdam);
    initContentCta(amsterdam, '.tih-city-content');
    // anchor
    $('.tih-city-profile', amsterdam).addClass('has-anchor').prepend('<a name="meet-antal"></a>');
    $('.tih-city-playlist', amsterdam).addClass('has-anchor').prepend('<a name="behind-the-songs"></a>');
    $($('.tih-city-intro', amsterdam).get(1)).addClass('has-anchor').prepend('<a name="masters-of-sound"></a>');
    amsterdam = $('.page-tih-city-amsterdam');
    initScrollHashEvent(amsterdam);
    initScrollHash(amsterdam);
    $(window).on('load hashchange', function() {
      initScrollHash(amsterdam);
    });
  }
  // tokyo
  var tokyo = $('.page-tih-city-tokyo');
  if (tokyo.length == 1) {
    initGalleryGrid(tokyo, 6, 'tokyo');
    initGallerySlideshow(tokyo, '.tih-city-gallery-thumbs', '.tih-city-gallery-slideshow', 20, 'tokyo');
    initGallerySlideshowCursor(tokyo);
    initVideo(tokyo);
    initContentCta(tokyo, '.tih-city-content');
    // anchor
    $('.tih-city-profile', tokyo).addClass('has-anchor').prepend('<a name="meet-daito"></a>');
    $('.tih-city-playlist', tokyo).addClass('has-anchor').prepend('<a name="behind-the-songs"></a>');
    $($('.tih-city-intro', tokyo).get(1)).addClass('has-anchor').prepend('<a name="masters-of-sound"></a>');
    tokyo = $('.page-tih-city-tokyo');
    initScrollHashEvent(tokyo);
    initScrollHash(tokyo);
    $(window).on('load hashchange', function() {
      initScrollHash(tokyo);
    });
  }
  // melbourne
  var melbourne = $('.page-tih-city-melbourne');
  if (melbourne.length == 1) {
    initGalleryGrid(melbourne, 6, 'melbourne');
    initGallerySlideshow(melbourne, '.tih-city-gallery-thumbs', '.tih-city-gallery-slideshow', 17, 'melbourne');
    updateGalleryGridSlideshow(melbourne, '.tih-city-gallery-thumbs', '.tih-city-gallery-slideshow', 6, 'melbourne')
    $(window).on('resize', function() {
      updateGalleryGridSlideshow(melbourne, '.tih-city-gallery-thumbs', '.tih-city-gallery-slideshow', 6, 'melbourne')
    });
    initGallerySlideshowCursor(melbourne);
    initVideo(melbourne);
    initContentCta(melbourne, '.tih-city-content');
    // anchor
    $($('.tih-city-intro', melbourne).get(0)).addClass('has-anchor').prepend('<a name="listen-city"></a>');
    $('.tih-city-content', melbourne).addClass('has-anchor').prepend('<a name="masters-of-sound"></a>');
    $('.tih-city-playlist', melbourne).addClass('has-anchor').prepend('<a name="behind-the-songs"></a>');
    $($('.tih-city-intro', melbourne).get(1)).addClass('has-anchor').prepend('<a name="meet-palm"></a>');
    melbourne = $('.page-tih-city-melbourne');
    initScrollHashEvent(melbourne);
    initScrollHash(melbourne);
    $(window).on('load hashchange', function() {
      initScrollHash(melbourne);
    });
  }
  // london
  var london = $('.page-tih-city-london');
  if (london.length == 1) {
    initGalleryGrid(london, 6, 'london');
    initGallerySlideshow(london, '.tih-city-gallery-thumbs', '.tih-city-gallery-slideshow', 20, 'london');
    // updateGalleryGridSlideshow(london, '.tih-city-gallery-thumbs', '.tih-city-gallery-slideshow', 6, 'london')
    // $(window).on('resize', function() {
    //   updateGalleryGridSlideshow(london, '.tih-city-gallery-thumbs', '.tih-city-gallery-slideshow', 6, 'london')
    // });
    initGallerySlideshowCursor(london);
    initVideo(london);
    initContentCta(london, '.tih-city-content');
    // anchor
    $($('.tih-city-intro', london).get(0)).addClass('has-anchor').prepend('<a name="listen-city"></a>');
    $('.tih-city-content', london).addClass('has-anchor').prepend('<a name="spotlight-sessions"></a>');
    $('.tih-city-playlist', london).addClass('has-anchor').prepend('<a name="behind-the-songs"></a>');
    $($('.tih-city-intro', london).get(1)).addClass('has-anchor').prepend('<a name="meet-victor"></a>');
    london = $('.page-tih-city-london');
    initScrollHashEvent(london);
    initScrollHash(london);
    $(window).on('load hashchange', function() {
      initScrollHash(london);
    });
  }
  // seoul
  var seoul = $('.page-tih-city-seoul');
  if (seoul.length == 1) {
    initGalleryGrid(seoul, 6, 'seoul');
    initGallerySlideshow(seoul, '.tih-city-gallery-thumbs', '.tih-city-gallery-slideshow', 20, 'seoul');
    // updateGalleryGridSlideshow(seoul, '.tih-city-gallery-thumbs', '.tih-city-gallery-slideshow', 6, 'seoul')
    // $(window).on('resize', function() {
    //   updateGalleryGridSlideshow(seoul, '.tih-city-gallery-thumbs', '.tih-city-gallery-slideshow', 6, 'seoul')
    // });
    initGallerySlideshowCursor(seoul);
    initVideo(seoul);
    initContentCta(seoul, '.tih-city-content');
    // anchor
    $($('.tih-city-intro', seoul).get(0)).addClass('has-anchor').prepend('<a name="listen-city"></a>');
    $('.tih-city-content', seoul).addClass('has-anchor').prepend('<a name="spotlight-sessions"></a>');
    $('.tih-city-playlist', seoul).addClass('has-anchor').prepend('<a name="behind-the-songs"></a>');
    $($('.tih-city-intro', seoul).get(1)).addClass('has-anchor').prepend('<a name="meet-sogumm"></a>');
    seoul = $('.page-tih-city-seoul');
    initScrollHashEvent(seoul);
    initScrollHash(seoul);
    $(window).on('load hashchange', function() {
      initScrollHash(seoul);
    });
  }
  // austin
  var austin = $('.page-tih-city-austin');
  if (austin.length == 1) {
    initGalleryGrid(austin, 6, 'austin');
    initGallerySlideshow(austin, '.tih-city-gallery-thumbs', '.tih-city-gallery-slideshow', 20, 'austin');
    // updateGalleryGridSlideshow(austin, '.tih-city-gallery-thumbs', '.tih-city-gallery-slideshow', 6, 'austin')
    // $(window).on('resize', function() {
    //   updateGalleryGridSlideshow(austin, '.tih-city-gallery-thumbs', '.tih-city-gallery-slideshow', 6, 'austin')
    // });
    initGallerySlideshowCursor(austin);
    initVideo(austin);
    initContentCta(austin, '.tih-city-content');
    // anchor
    $($('.tih-city-intro', austin).get(0)).addClass('has-anchor').prepend('<a name="listen-city"></a>');
    $('.tih-city-content', austin).addClass('has-anchor').prepend('<a name="spotlight-sessions"></a>');
    $('.tih-city-playlist', austin).addClass('has-anchor').prepend('<a name="behind-the-songs"></a>');
    $($('.tih-city-intro', austin).get(1)).addClass('has-anchor').prepend('<a name="meet-"></a>');
    austin = $('.page-tih-city-austin');
    initScrollHashEvent(austin);
    initScrollHash(austin);
    $(window).on('load hashchange', function() {
      initScrollHash(austin);
    });
  }
});

function initScrollHash(el) {
  var hash = window.location.hash.replace('#', '');
  var anchor =  $('a[name="'+hash+'"]', el);
  if (hash != '' && anchor.length > 0) {
    $('html,body').stop().animate({
      scrollTop: anchor.offset().top - $('#header').outerHeight(),
    }, 300);
  }
}

function initScrollHashEvent(el) {
  $('a', el).on('click', function(e) {
    var hash = $(e.target).attr('href').replace('#', '');
    var anchor =  $('a[name="'+hash+'"]', el);
    if (hash != '' && anchor.length > 0) {
      $('html,body').stop().animate({
        scrollTop: anchor.offset().top - $('#header').outerHeight(),
      }, 300);
      e.preventDefault();
    }
  });
}

function initGallerySlideshowCursor(el) {
  var cursor = $('.tih-city-gallery-slideshow .swiper-cursor', el);
  $('.tih-city-gallery-slideshow', el).on('mouseover', function(e) {
    var _t = $(e.target);
    if (_t.hasClass('swiper-button')) {
      cursor.addClass('active');
      if (_t.hasClass('swiper-button-prev')) {
        cursor.addClass('swiper-cursor-prev').removeClass('swiper-cursor-next');
      } else if (_t.hasClass('swiper-button-next')) {
        cursor.addClass('swiper-cursor-next').removeClass('swiper-cursor-prev');
      } else {
        cursor.removeClass('swiper-cursor-prev').removeClass('swiper-cursor-next');
      }
    } else {
      cursor.removeClass('active');
    }
  }).on('mouseleave', function(e) {
    cursor.removeClass('active');
  }).on('mousemove touchmove', function(e) {
    var x = !isTouchDevice() ? e.pageX : e.touches[0].pageX;
    var y = !isTouchDevice() ? e.pageY : e.touches[0].pageY;
    var offset = $('.tih-city-gallery-slideshow').offset();
    x = x - offset.left;
    y = y - offset.top;
    cursor.css({
      // left: `${x}px`,
      // top: `${y}px`,
      // transform: `translate3d(calc(${x}px - 0%), calc(${y}px - 0%), 0)`,
      transform: `matrix(1, 0, 0, 1, ${x}, ${y}) translate3d(-50%, -50%, 0px)`,
    });
  });
}

var gallery_thumbs_swiper, gallery_slideshow_swiper;
function initGallerySlideshow(el, thumb_class, slider_class, total, folder_name) {
  var gallery_thumbs_slides = $('.tih-city-gallery-thumbs .swiper .swiper-wrapper', el);
  var gallery_slideshow_slides = $('.tih-city-gallery-slideshow .swiper .swiper-wrapper', el);
  for (var i = 1; i <= total; i++) {
    var fi = String(i).toString().padStart(2, '0');
    var folder_names_v1 = ['amsterdam','tokyo'];
    var folder_names_v2 = ['melbourne','london','seoul','austin'];
    var folder_names_v3 = ['london','seoul','austin'];
    var tb_folder = folder_names_v2.indexOf(folder_name) >= 0 ? 'tb' : 'tb-mb';
    var mb_folder = folder_names_v2.indexOf(folder_name) >= 0 ? 'mb' : 'tb-mb';
    var img_ext = folder_names_v3.indexOf(folder_name) >= 0 ? 'jpg' : 'png';
    gallery_thumbs_slides.append(`<div class="swiper-slide">
      <img src="https://assets.kef.com/take-it-home/${folder_name}/event-gallery/dt/thumbnails/gallery-${fi}-thumbnail.${img_ext}" alt="" loading="lazy" class="show-desktop">
      <img src="https://assets.kef.com/take-it-home/${folder_name}/event-gallery/${tb_folder}/thumbnails/gallery-${fi}-thumbnail.${img_ext}" alt="" loading="lazy" class="show-tablet">
      <img src="https://assets.kef.com/take-it-home/${folder_name}/event-gallery/${mb_folder}/thumbnails/gallery-${fi}-thumbnail.${img_ext}" alt="" loading="lazy" class="show-mobile">
    </div>`);

    gallery_slideshow_slides.append(`<div class="swiper-slide">
      <img src="https://assets.kef.com/take-it-home/${folder_name}/event-gallery/dt/gallery-${fi}-dt.${img_ext}" alt="" loading="lazy" class="show-desktop">
      <img src="https://assets.kef.com/take-it-home/${folder_name}/event-gallery/${tb_folder}/gallery-${fi}-${tb_folder}.${img_ext}" alt="" loading="lazy" class="show-tablet">
      <img src="https://assets.kef.com/take-it-home/${folder_name}/event-gallery/${mb_folder}/gallery-${fi}-${mb_folder}.${img_ext}" alt="" loading="lazy" class="show-mobile">
    </div>`);
  };
  gallery_thumbs_swiper = new Swiper(`${thumb_class} .swiper`, {
    direction: 'horizontal',
    loop: true,
    loopedSlides: 6,
    spaceBetween: 8,
    slidesPerView: 'auto',
    slideToClickedSlide: true,
    // freeMode: true,
    // watchSlidesProgress: true,
    initialSlide: $(`${thumb_class} .swiper-slide-active`).index() || 0,
    pagination: {
      el: `${thumb_class} .swiper-pagination`,
      clickable: true,
    },
    navigation: {
      nextEl: `${thumb_class} .swiper-button-next`,
      prevEl: `${thumb_class} .swiper-button-prev`,
    },
    scrollbar: {
      el: `${thumb_class} .swiper-scrollbar`,
    },
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {
      768: {
        direction: 'vertical',
      },
    },
  });
  gallery_slideshow_swiper = new Swiper(`${slider_class} .swiper`, {
    direction: 'horizontal',
    loop: true,
    loopedSlides: 6,
    initialSlide: $(`${slider_class} .swiper-slide-active`).index() || 0,
    pagination: {
      el: `${slider_class} .swiper-pagination`,
      // clickable: true,
      renderCustom: function(swiper, current, total) {
        return current + '/' + total;
      },
      type: 'custom',
    },
    navigation: {
      nextEl: `${slider_class} .swiper-button-next`,
      prevEl: `${slider_class} .swiper-button-prev`,
    },
    scrollbar: {
      el: `${slider_class} .swiper-scrollbar`,
    },
    mousewheel: {
      forceToAxis: true,
    },
    thumbs: {
      swiper: gallery_thumbs_swiper,
      multipleActiveThumbs: false,
    },
    breakpoints: {
      768: {
      },
    },
    on: {
      slideChange: function() {
        video_player.stopAll();
      },
    },
  });
  // gallery_thumbs_swiper.controller.control = gallery_slideshow_swiper;
  // gallery_slideshow_swiper.controller.control = gallery_thumbs_swiper;
}
var is_mobile = false;
function updateGalleryGridSlideshow(el, thumb_class, slider_class, total, folder_name) {
  console.log($(window).width() < 768 && !is_mobile, $(window).width() >= 768 && is_mobile);
  if ($(window).width() < 768 && !is_mobile) {
    var gallery_thumbs_slides = [], 
        gallery_slideshow_slides = [];
    for (var i = 1; i <= total; i++) {
      var fi = String(i).toString().padStart(2, '0');
      var folder_names_v1 = ['amsterdam','tokyo'];
      var folder_names_v2 = ['melbourne','london','seoul','austin'];
      var folder_names_v3 = ['london','seoul','austin'];
      var mb_folder = folder_names_v2.indexOf(folder_name) >= 0 ? 'mb' : 'tb-mb';
      var img_ext = folder_names_v3.indexOf(folder_name) >= 0 ? 'jpg' : 'png';

      gallery_thumbs_slides.push(`<div class="swiper-slide">
        <img src="https://assets.kef.com/take-it-home/${folder_name}/event-gallery/${mb_folder}/thumbnails/gallery-grid-${fi}-thumbnail.${img_ext}" alt="" loading="lazy" class="show-mobile">
      </div>`);

      gallery_slideshow_slides.push(`<div class="swiper-slide">
        <img src="https://assets.kef.com/take-it-home/${folder_name}/event-gallery/${mb_folder}/gallery-grid-img-${fi}-${mb_folder}.${img_ext}" alt="" loading="lazy" class="show-mobile">
      </div>`);
    }
    gallery_thumbs_swiper.appendSlide(gallery_thumbs_slides);
    gallery_slideshow_swiper.appendSlide(gallery_slideshow_slides);

    is_mobile = true;
  } else if ($(window).width() >= 768 && is_mobile) {
    var idx = $('.tih-city-gallery-thumbs .swiper .swiper-slide', el).length - 1,
        idx_total = idx - total,
        idxs = [];
    for (var i = idx; i > idx_total; i--) {
      idxs.push(i);
    }
    gallery_thumbs_swiper.removeSlide(idxs);
    gallery_slideshow_swiper.removeSlide(idxs);

    is_mobile = false;
  }
}

function initGalleryGrid(el, total, folder_name) {
  var gallery_grid_slides = $('.tih-city-gallery-grid', el);
  for (var i = 1; i <= total; i++) {
    var fi = String(i).toString().padStart(2, '0');
    var folder_names_v3 = ['london','seoul','austin'];
    var img_ext = folder_names_v3.indexOf(folder_name) >= 0 ? 'jpg' : 'png';
    gallery_grid_slides.append(`<div class="tih-city-gallery-grid-item" style="grid-area: a${i};">
      <img src="https://assets.kef.com/take-it-home/${folder_name}/dt/grid-img-${fi}-dt.${img_ext}" alt="" loading="lazy" class="show-desktop">
      <img src="https://assets.kef.com/take-it-home/${folder_name}/tb/grid-img-${fi}-tb.${img_ext}" alt="" loading="lazy" class="show-tablet">
      <img src="https://assets.kef.com/take-it-home/${folder_name}/mb/grid-img-${fi}-mb.${img_ext}" alt="" loading="lazy" class="show-mobile">
    </div>`)
  }
}

function initContentCta(el, slider_class) {
  var content_cta_swiper = new Swiper(`${slider_class} .swiper`, {
    direction: 'horizontal',
    loop: false,
    spaceBetween: 0,
    slidesPerView: 1.1,
    roundLengths: true,
    freeMode: true,
    pagination: {
      el: `${slider_class} .swiper-pagination`,
      clickable: true,
    },
    navigation: {
      nextEl: `${slider_class} .swiper-button-next`,
      prevEl: `${slider_class} .swiper-button-prev`,
    },
    scrollbar: {
      el: `${slider_class} .swiper-scrollbar`,
    },
    mousewheel: {
      forceToAxis: true,
    },
    breakpoints: {
      576: {
        loop: false,
        slidesPerView: 2.1,
      },
      768: {
        slidesPerView: $(`${slider_class} .swiper-slide`).length,
      },
    },
  });

  $('.tih-ctas a').each(function() {
    var _t = $(this);
    if (_t.attr('href').indexOf('/pages/book-a-demo') >= 0) {
      _t.addClass('tih-cta-link-book-a-demo');
    } else if (_t.attr('href').indexOf('/pages/store-locator') >= 0) {
      _t.addClass('tih-cta-link-store-locator');
    } else if (_t.attr('href').indexOf('/pages/take-it-home') >= 0) {
      _t.addClass('tih-cta-link-take-it-home');
    }
  });
}

function initVideo(el) {
  video_player.init();
  $('.video-player-box .btn-play', el).on('click', function(e) {
    var vid = $(this);
    video_player.stopAll();
    video_player.play(vid);
    e.preventDefault();
  });
  $('.video-player-box .video-player', el).on('click', function(e) {
    var vid = $(this);
    if (vid.parent('.video-player-box').hasClass('paused')) {
      video_player.play(vid);
    } else if (vid.parent('.video-player-box').hasClass('playing')) {
      video_player.pause(vid);
    }
    e.preventDefault();
  });
  // $('.video-player-box .btn-play').on('click', function(e) {
  //   var vid = $(this);
  //   console.log('apple')
  //   video_player.play(vid);
  // });
  $(window).on('resize', function() {
    resizeIframe($('.video-player', el));
  });
}

function resizeIframe(_t) {
  return false;

  var iframe = $('iframe', _t);
  if (iframe.length == 0) return;
  iframe.removeAttr('style');

  // multi iframe
  // console.log(_t.width(), _t.height())
  if (window.innerWidth >= 1024) {
    // 16x9
    var h = _t.width() / 16 * 9 / _t.height();
    // console.log('16x9', h)
    if (h > 1) {
      iframe.css({
        height: `${h * 100}%`,
      });
    } else {
      var w = _t.height() / 9 * 16 / _t.width();
      // console.log('16x9', w)
      iframe.css({
        width: `${w * 100}%`,
      });
    }
  } else if (window.innerWidth >= 768) {
    // 1x1
    if (_t.width() > _t.height()) {
      // console.log('1x1', _t.width())
      iframe.css({
        height: _t.width(),
      });
    } else {
      // console.log('1x1', _t.height())
      var w = _t.height() / 5 / 4 / _t.width();
      iframe.css({
        width: _t.height(),
      });
    }
  } else {
    // 4x5
    var h = _t.width() / 4 * 5 / _t.height();
    // console.log('4x5', h)
    if (h > 1) {
      iframe.css({
        height: `${h * 100}%`,
      });
    } else {
      var w = _t.height() / 5 * 4 / _t.width();
      // console.log('4x5', w)
      iframe.css({
        width: `${w * 100}%`,
      });
    }
  }
}

function isTouchDevice() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

function initNewsletter() {
  var el = $('.tih-city-newsletter-placeholder');
  if (el.length == 0) return false;

  var form = $('.tih-city-newsletter-form');
  if (form.length == 0) {
    el.remove();
    return false;
  }

  el.get(0).outerHTML = form.removeAttr('style').get(0).outerHTML;
  form = $('.tih-city-newsletter-form');
  form.prepend('<a name="contact_form"></a>');
  $('#shopify-section-newsletter-form').remove();
}

function initBackToTop() {
  var aria_texts = general.decodeLocale(window.kef.assets.aria.texts);
  $('#page-tih-city').append('<a href="javascript:void(0);" id="back-to-top" aria-label="' + aria_texts.back_to_top + '"></a>');
  general.initBackToTop();
}